/* Parineeta — cart reward ladder.
   Adds or removes the free Last Piece as a real cart line. Shopify's
   "Last Piece gift" automatic discounts are what price it at zero, so the
   line shows as 0 in the cart and at checkout. */
(function () {
  var BUSY = false;
  var root = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      window.location.reload();
      return;
    }
    fetch(root() + '?section_id=cart-drawer')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var current = drawer.querySelector('.drawer__inner');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          drawer.classList.toggle('is-empty', html.indexOf('cart-drawer-items class=" is-empty"') > -1);
        } else {
          window.location.reload();
          return;
        }
        return fetch(root() + '?section_id=cart-icon-bubble')
          .then(function (r) {
            return r.text();
          })
          .then(function (bubbleHtml) {
            var target = document.getElementById('cart-icon-bubble');
            var incoming = new DOMParser()
              .parseFromString(bubbleHtml, 'text/html')
              .querySelector('.shopify-section');
            if (target && incoming) target.innerHTML = incoming.innerHTML;
          })
          .catch(function () {});
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function post(url, payload) {
    if (BUSY) return;
    BUSY = true;
    fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function () {
        BUSY = false;
        refresh();
      })
      .catch(function () {
        BUSY = false;
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var add = event.target.closest('[data-pr-add]');
    if (add) {
      event.preventDefault();
      add.disabled = true;
      add.textContent = 'Adding…';
      post('cart/add.js', { items: [{ id: Number(add.dataset.prAdd), quantity: 1 }] });
      return;
    }

    var remove = event.target.closest('[data-pr-remove]');
    if (remove) {
      event.preventDefault();
      remove.disabled = true;
      post('cart/change.js', { id: remove.dataset.prRemove, quantity: 0 });
    }
  });
})();
